import 'antd/es/slider/style';

import React, { memo } from 'react';

import NewEmailDialog from '@/components/NewEmailDialog';
import MainLayout from '@/layout/MainLayout';
import { useIsAdminByRoles, useIsBasicUser } from '@/modules/admin/hooks/useUser';
import ModulesRouter from '@/modules/ModulesRouter';
import ModulesUserRouter from '@/modules/ModulesUserRouter';

const Modules = () => {
  const isUser = useIsBasicUser();
  const isAdmin = useIsAdminByRoles();
  
  return (
    <MainLayout>
      {isUser && !isAdmin ? <ModulesUserRouter/> : <ModulesRouter/>}
      <NewEmailDialog/>
    </MainLayout>
  );
};

export default memo(Modules);
